customElements.define(
  'quick-add-drawer',
  class QuickAddDrawer extends HTMLElement {
    connectedCallback() {
      this.setNodeSelectors();
      this.setEventListeners();
    }

    /**
     * Sets the node selectors.
     */
    setNodeSelectors() {
      this.nodeSelectors = {
        toggleElement: this.querySelector('[js-quick-add-drawer="toggleElement"]'),
        productContent: this.querySelector('[js-quick-add-drawer="productContent"]'),
        loader: this.querySelector('[js-quick-add-drawer="loader"]'),
      };
    }

    /**
     * Sets the event listeners.
     */
    setEventListeners() {
      theme.eventBus.listen('quick-add-drawer:open', async ({ productHandle, variantId }) => {
        this.openToggleElement();

        if (!variantId) {
          if (productHandle === this.productHandle) {
            return;
          }
        } else {
          if (productHandle === this.productHandle && variantId === this.variantId) {
            return;
          }
        }

        this.setLoadingState();

        this.setDefaultProductContent(productHandle, variantId).then(() => {
          this.productHandle = productHandle;
          this.variantId = variantId;

          this.setLoadingState(true);
        });
      });
    }

    /**
     * Sets event listeners on dynamic elements.
     */
    setDynamicEventListeners() {
      const productForm = this.getProductForm();

      if (productForm) {
        productForm.addEventListener('variant', async (event) => {
          const content = await this.getProductContent(event.detail.product.handle, event.detail.id);

          replaceElement(this, content, '[js-quick-add-product="image"]');

          if (content) {
            replaceProductForm(productForm, content.querySelector('product-form'));
          }
        });
      }
    }

    /**
     * Opens the toggle element.
     */
    openToggleElement() {
      this.nodeSelectors.toggleElement.open();
    }

    /**
     * Sets the loading state.
     * @param {Boolean} remove - Removes the loading state.
     */
    setLoadingState(remove = false) {
      if (remove) {
        this.nodeSelectors.productContent.classList.add('is-active');
        this.nodeSelectors.loader.classList.remove('is-active');
        return;
      }

      this.nodeSelectors.productContent.classList.remove('is-active');
      this.nodeSelectors.loader.classList.add('is-active');
    }

    /**
     * Fetches the product section and sets it in the drawer.
     * @param {String} productHandle - The product handle.
     * @param {Number} variantId - The selected variant ID (optional).
     */
    async setDefaultProductContent(productHandle, variantId) {
      const content = await this.getProductContent(productHandle, variantId);

      if (content) {
        this.nodeSelectors.productContent.innerHTML = content.innerHTML;
        this.setDynamicEventListeners();
      }
    }

    /**
     * Fetches and returns the product content.
     * @param {String} productHandle - The product to fetch.
     * @returns {Promise<HTMLElement>}
     */
    // async getProductContent(productHandle, variantId) {
    //   const section = await fetch(
    //     `${theme.routes.root_url}products/${productHandle}?section_id=quick-add-product${
    //       variantId ? `&variant=${variantId}` : ''
    //     }`
    //   ).then((response) => response.text());
    //   const html = new DOMParser().parseFromString(section, 'text/html');

    //   return html.getElementById('shopify-section-quick-add-product');
    // }
    async getProductContent(productHandle, variantId) {
      console.log("here get quick content");
      console.log(theme.routes.root_url , "url");
    
      // ✅ Fix: Ensure trailing slash between root_url and 'products/...'
      const rootUrl = theme.routes.root_url.endsWith('/')
        ? theme.routes.root_url
        : `${theme.routes.root_url}/`;
    
      const section = await fetch(
        `${rootUrl}products/${productHandle}?section_id=quick-add-product${
          variantId ? `&variant=${variantId}` : ''
        }`
      ).then((response) => response.text());
    
      const html = new DOMParser().parseFromString(section, 'text/html');
      return html.getElementById('shopify-section-quick-add-product');
    }

    /**
     * Returns the product form, if it exists.
     * @returns {HTMLElement}
     */
    getProductForm() {
      return this.nodeSelectors.productContent.querySelector('product-form');
    }
  }
);
